// import React, { useEffect, useRef, useState } from "react";
// import {
//   startOrderPolling,
//   subscribeOrderUpdates,
// } from "../../../utils/odsArchitecture/orderPollingService";
// import "./FloatingOrderIsland.css";
// import { processOrders, subscribeNewOrders } from "../../../utils/orderNewTracker/orderNewTracker";

// const FloatingOrderIsland = () => {
//   const [createdCount, setCreatedCount] = useState(0);
//   const [newOrderIds, setNewOrderIds] = useState(new Set());

//   const [position, setPosition] = useState({ x: 100, y: 100 });
//   const dragging = useRef(false);
//   const offset = useRef({ x: 0, y: 0 });

//   useEffect(() => {
//     startOrderPolling();

//     const unsubscribeOrders = subscribeOrderUpdates(({ data }) => {
//       const list = data?.orderResponseList || [];

//       processOrders(list);

//       const createdOrders = list.filter(
//         (item) => item?.baseOrderResponse?.fulfilmentStatus === "CREATED"
//       );

//       setCreatedCount(createdOrders?.length);
//     });

//     const unsubscribeNew = subscribeNewOrders((ids) => {
//       setNewOrderIds(ids);
//     });

//     return () => {
//       unsubscribeOrders();
//       unsubscribeNew();
//     };
//   }, []);

//   const isBlinking = newOrderIds.size > 0;

//   const handleMouseDown = (e) => {
//     dragging.current = true;
//     offset.current = {
//       x: e.clientX - position?.x,
//       y: e.clientY - position?.y,
//     };
//   };

//   const handleMouseMove = (e) => {
//     if (!dragging.current) return;

//     const newX = e.clientX - offset.current.x;
//     const newY = e.clientY - offset.current.y;

//     const maxX = window.innerWidth - 150;
//     const maxY = window.innerHeight - 60;

//     setPosition({
//       x: Math.max(0, Math.min(newX, maxX)),
//       y: Math.max(0, Math.min(newY, maxY)),
//     });
//   };

//   const handleMouseUp = () => {
//     dragging.current = false;
//   };

//   useEffect(() => {
//     window.addEventListener("mousemove", handleMouseMove);
//     window.addEventListener("mouseup", handleMouseUp);

//     return () => {
//       window.removeEventListener("mousemove", handleMouseMove);
//       window.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, []);

//   return (
//     <div
//       className={`floating-island ${isBlinking ? "blink" : ""}`}
//       style={{ top: position?.y, left: position?.x }}
//       onMouseDown={handleMouseDown}
//     >
//       <div className="island-content">
//         <span className="dot" />
//         <span className="text">New Orders</span>
//         <span className="count">{createdCount}</span>
//       </div>
//     </div>
//   );
// };

// export default FloatingOrderIsland;
